module.exports = __webpack_public_path__ + "img/icon_time_wghn.d63d1dbb.svg";